export default {
  init() {
    // JavaScript to be fired on all pages
    this.workSlider();
    this.feedbackSlider();
    this.labelClass();
    this.callModal();
    this.showMore();
    this.svgTritatushinki();
  },

  workSlider() {
    let slider = $('.front-page__work-content');

    slider.addClass('owl-carousel')
      .owlCarousel({
        center: false,
        loop: false,
        margin: 21,
        nav: true,
        dots: true,
        items: 3,
        autoplay: false,
        autoplayTimeout: 7500,
        autoplayHoverPause: false,
        autoHeight: false,
        autoplaySpeed: 1000,
        navSpeed: 2000,
        mouseDrag: true,
        touchDrag: true,
        responsive: {
          0: {
            items: 1,
          },
          560: {
            items: 2,
            margin: 15,
          },
          990: {
            items: 3,
          },
          1220: {
            items: 3,
          },
        },
      });

    $('.front-page__work-item-image').magnificPopup({
      type: 'image',
      gallery: {
        enabled: true,
        tCounter: '%curr% из %total%',
      },
      callbacks: {
        elementParse: function (qw) {
          qw.src = qw.el.attr('src');
        },
      },
    });
  },

  feedbackSlider() {
    let slider2 = $('.front-page__feedback-content');

    slider2.addClass('owl-carousel')
      .owlCarousel({
        center: false,
        loop: false,
        margin: 20,
        nav: true,
        dots: true,
        items: 5,
        autoplay: false,
        autoplayTimeout: 7500,
        autoplayHoverPause: false,
        autoHeight: false,
        autoplaySpeed: 1000,
        navSpeed: 2000,
        mouseDrag: true,
        touchDrag: true,
        responsive: {
          0: {
            items: 1.4,
          },
          560: {
            items: 2.5,
          },
          768: {
            items: 3.5,
          },
          990: {
            items: 4,
          },
          1220: {
            items: 5,
          },
        },
      });

    $('.front-page__feedback-item-image').magnificPopup({
      type: 'image',
      gallery: {
        enabled: true,
        tCounter: '%curr% из %total%',
      },
      callbacks: {
        elementParse: function (qw) {
          qw.src = qw.el.attr('src');
        },
      },
    });
  },

  labelClass() {
    $('.wpcf7-form-wrapper-checkbox label').click(function (e) {
      e.preventDefault();
      $(this).toggleClass('checked');
      if ($(this).hasClass('checked')) {
        $(this).find('input').prop('checked', true);
      } else {
        $(this).find('input').prop('checked', false);
      }
    });
  },

  callModal() {
    $('.banner__header-button-btn').on('click', function (e) {
      e.preventDefault();
      $('.modal__wrapper').fadeIn(250);
      $('#wpcf7-f111-o1').fadeIn(250);
      $('#wpcf7-f111-o2').fadeIn(250);
      $('#wpcf7-f111-o3').fadeIn(250);
    });

    $('.modal__wrapper, .modal__block-close-modal').on('click', (e) => {
      if ($(e.target).hasClass('modal__wrapper') || $(e.target).hasClass('modal__block-close-modal')) {
        $('.modal__wrapper').fadeOut(250);
        $('.modal__block > .wpcf7').fadeOut(250);
      }
    });
  },

  showMore() {
    $('.front-page__service-show-more').click(function (e) {
      e.preventDefault();
      $(this).parent().find('.front-page__service-item:nth-of-type(n+4)').toggleClass('active');
      //$('.about-page__feedback .pagination').toggleClass('hide');
      $(this).text($(this).text() == 'Еще услуги' ? 'Свернуть' : 'Еще услуги');
    });
  },

  svgTritatushinki() {
    const window = $('.window')
    window.attr('fill', '#455A64');

    setInterval(() => {
      window.each(function() {
        if($(this).hasClass('active')) {
          setTimeout(() => {
            //window.removeClass('active');
            window.attr('fill', '#455A64');
            let next = window.eq(window.index($(this)) + 1);
            if(next.length < 1) {
              next = window.eq(0);
            }

            next.addClass('active');
            next.attr('fill', '#E9B248');
          }, 600);
        }
      })
    }, 600);
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js